import { selfAxios } from "../../../../axios/selfAxios.js";
async function reqGetWhitelistPageList(params) {
  const { data } = await selfAxios.get("/mtdsbase/whitelist/getWhitelistPageList", { params, _cache: true });
  return data.data;
}
export { reqGetWhitelistPageList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/mtdsbase/whitelist/getWhitelistPageList/get.js